import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import Icon from 'flarum/common/components/Icon';
import { isEmail } from '../../common/accountRules';
const t = (key, params) => app.translator.trans('ppk2-profile.forum.support.' + key, params);
export const COMMENT_MAX = 1000;

/**
 * «Написать в техподдержку» inside the registration form, under «Ник уже занят»: a small
 * inline panel (no second modal, so nothing typed in the form is lost). Nick read-only,
 * «Ваша почта для связи» (prefilled from the form's Email when valid), optional comment,
 * hidden honeypot field. POST /api/ppk2/support-requests; then «Спасибо! …».
 * attrs: nick, email (initial), onclose()
 */
export default class SupportPanel extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    this.email = isEmail(this.attrs.email) ? String(this.attrs.email).trim() : '';
    this.comment = '';
    this.website = '';
    this.loading = false;
    this.sent = false;
    this.errors = {};
    this.tried = false;
  }
  view() {
    const nick = this.attrs.nick;
    if (this.sent) {
      return m("div", {
        className: "Ppk2Support Ppk2Support--done",
        role: "status"
      }, m(Icon, {
        name: "fas fa-circle-check"
      }), " ", m("span", null, t('done')), m(Button, {
        className: "Button Button--link Ppk2Support-close",
        onclick: () => this.attrs.onclose()
      }, t('back')));
    }
    const emailBad = (this.tried || this.email) && !isEmail(this.email);
    return m("div", {
      className: "Ppk2Support",
      role: "group",
      "aria-label": t('title')
    }, m("div", {
      className: "Ppk2Support-title"
    }, m(Icon, {
      name: "fas fa-headset"
    }), " ", t('title')), m("p", {
      className: "Ppk2Support-intro"
    }, t('intro')), m("div", {
      className: "Ppk2Support-grid"
    }, m("label", {
      for: "ppk2-sp-nick"
    }, t('nick')), m("input", {
      id: "ppk2-sp-nick",
      className: "FormControl",
      type: "text",
      value: nick,
      readonly: true,
      tabindex: "-1"
    }), m("label", {
      for: "ppk2-sp-email"
    }, t('email')), m("div", null, m("input", {
      id: "ppk2-sp-email",
      className: 'FormControl' + (emailBad || this.errors.email ? ' Ppk2SignUp-bad' : this.email ? ' Ppk2SignUp-ok' : ''),
      type: "email",
      name: "ppk2SupportEmail",
      autocomplete: "email",
      maxlength: "150",
      placeholder: t('email_ph'),
      value: this.email,
      disabled: this.loading,
      oninput: e => (this.email = e.target.value, delete this.errors.email),
      onkeydown: e => {
        // Enter here sends the request, not the registration form around it
        if (e.key === 'Enter') {
          e.preventDefault();
          this.send();
        }
      }
    }), this.errors.email ? m("div", {
      className: "Ppk2SignUp-status Ppk2SignUp-status--bad"
    }, m(Icon, {
      name: "fas fa-circle-xmark"
    }), " ", this.errors.email) : emailBad ? m("div", {
      className: "Ppk2SignUp-status Ppk2SignUp-status--bad"
    }, m(Icon, {
      name: "fas fa-circle-xmark"
    }), " ", app.translator.trans('ppk2-profile.forum.signup.email_invalid')) : null), m("label", {
      for: "ppk2-sp-comment"
    }, t('comment')), m("div", null, m("textarea", {
      id: "ppk2-sp-comment",
      className: 'FormControl' + (this.errors.comment ? ' Ppk2SignUp-bad' : ''),
      rows: "2",
      maxlength: COMMENT_MAX,
      placeholder: t('comment_ph'),
      value: this.comment,
      disabled: this.loading,
      oninput: e => (this.comment = e.target.value, delete this.errors.comment)
    }), m("div", {
      className: "Ppk2Support-count"
    }, this.comment.length, "/", COMMENT_MAX), this.errors.comment ? m("div", {
      className: "Ppk2SignUp-status Ppk2SignUp-status--bad"
    }, this.errors.comment) : null)), m("div", {
      className: "Ppk2Support-hp",
      "aria-hidden": "true"
    }, m("input", {
      type: "text",
      name: "website",
      tabindex: "-1",
      autocomplete: "off",
      value: this.website,
      oninput: e => this.website = e.target.value
    })), this.errors.other ? m("div", {
      className: "Ppk2SignUp-status Ppk2SignUp-status--bad"
    }, this.errors.other) : null, m("div", {
      className: "Ppk2Support-buttons"
    }, m(Button, {
      className: "Button Button--primary",
      type: "button",
      icon: "fas fa-paper-plane",
      loading: this.loading,
      onclick: () => this.send()
    }, t('send')), m(Button, {
      className: "Button",
      type: "button",
      disabled: this.loading,
      onclick: () => this.attrs.onclose()
    }, t('cancel'))));
  }
  send() {
    this.tried = true;
    if (!isEmail(this.email) || this.comment.length > COMMENT_MAX) return;
    this.loading = true;
    this.errors = {};
    app.request({
      method: 'POST',
      url: app.forum.attribute('apiUrl') + '/ppk2/support-requests',
      body: {
        nick: this.attrs.nick,
        email: this.email.trim(),
        comment: this.comment,
        website: this.website
      },
      errorHandler: error => {
        const list = error.response && error.response.errors || [];
        list.forEach(e => {
          const field = (e.source && e.source.pointer || '').split('/').pop();
          this.errors[field === 'email' || field === 'comment' ? field : 'other'] = e.detail;
        });
        if (!list.length) this.errors.other = error.status === 429 ? app.translator.trans('ppk2-profile.lib.support.error_too_many') : error.message || 'Error';
      }
    }).then(() => this.sent = true, () => {}).finally(() => {
      this.loading = false;
      m.redraw();
    });
  }
}
flarum.reg.add('ppk2-profile', 'forum/signup/SupportPanel', SupportPanel);